import { pageHead } from "@app/framework/meta";
import { InvestorBasicInformationPage } from "@modules/investor/pages";
import { trans } from "@mongez/localization";
import { MetaFunction, useLoaderData } from "@remix-run/react";

// export const loader: LoaderFunction = async ({
//   request,
// }: LoaderFunctionArgs) => {
//   const { http, success, catchErrors } = await getLoaderEndpoint(request);

//   try {
//     const { data } = await getBasicInfoServices(http);

//     return success(data);
//   } catch (error: any) {
//     return catchErrors(error);
//   }
// };

export default function BasicInfo() {
  useLoaderData();

  return <InvestorBasicInformationPage />;
}

export const meta: MetaFunction = ({ data }: any) => {
  return pageHead({
    title: data?.metaData?.title || trans("basicInfo.title"),
    description: data?.metaData?.description || trans("basicInfo.description"),
  });
};
